import React from "react";

/**
 * IndoBlitz byline with the gold owl-and-wings mark. Used in the bottom footer
 * only. The mark is deliberately small (h-8 max) so it does NOT overpower the
 * Aarya wordmark or content - brand should be felt, not announced.
 */
export default function IndoBlitzByline({ className = "" }) {
  return (
    <div className={`flex flex-col items-center gap-1 select-none ${className}`} data-testid="indoblitz-byline">
      <img
        src="/indoblitz-logo.webp"
        alt="IndoBlitz"
        className="h-8 w-auto opacity-70"
        loading="lazy"
        draggable="false"
      />
      <p className="text-center text-[10px] text-ink-500 tracking-wide">
        An IndoBlitz product · Made in India 🇮🇳
      </p>
    </div>
  );
}

// Backwards-compat exports so existing imports don't break.
export const IndoBlitzFooter = IndoBlitzByline;
export function IndoBlitzTag() { return null; } // Deprecated - no longer shown.
